import { useMemo } from "react";

enum LogLevel {
  INFO = 'info',
  ERROR = 'error',
  WARN = 'warn',
  DEBUG = 'debug',
  TRACE = 'trace'
}

export class Logger {
  private static readonly endpoint: string = '/.netlify/functions/logger';

  info(message: string) {
    this.callLoggerEndpoint(message, LogLevel.INFO);
  }

  error(message: string) {
    this.callLoggerEndpoint(message, LogLevel.ERROR);
  }

  warn(message: string) {
    this.callLoggerEndpoint(message, LogLevel.WARN);
  }

  debug(message: string) {
    this.callLoggerEndpoint(message, LogLevel.DEBUG);
  }

  trace(message: string) {
    this.callLoggerEndpoint(message, LogLevel.TRACE);
  }

  private callLoggerEndpoint(message: string, logLevel: LogLevel): void {
    try {
      fetch(Logger.endpoint, { method: 'POST', body: this.makeLoggerPayload(message, logLevel) });
    } catch (error) {
      console.error(`Failed to call logger function at ${Logger.endpoint}`, error);
    }
  }

  private makeLoggerPayload(message: string, logLevel: LogLevel): string {
    return JSON.stringify({ message, logLevel });
  }
}

const useLogger = (): Logger => {
  return useMemo(() => new Logger(), []);
}

export default useLogger;
